const utilities = {
    updateFontSize(size) {
        const dom = document.querySelector('html')
        dom.style.fontSize = size/100 + 'em'
        dom.style.setProperty('--icon-size', size/100 + 'em')
    }
}

export default utilities